import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { useData } from "@/context/DataContext";
import { PageHeader } from "@/components/Common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Audit() {
  const { nameOf } = useData();
  const [data, setData] = useState({ events: [], access: [] });
  useEffect(() => { api.get("/audit").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="audit-page">
      <PageHeader eyebrow="Audit · GDPR" title="Registro modifiche" />
      <Tabs defaultValue="events">
        <TabsList className="mb-4 rounded-none border bg-white">
          <TabsTrigger value="events" data-testid="audit-tab-events">Modifiche ({data.events.length})</TabsTrigger>
          <TabsTrigger value="access" data-testid="audit-tab-access">Accessi ({data.access.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="events">
          <div className="overflow-x-auto border bg-white" data-testid="audit-events-table">
            <Table>
              <TableHeader><TableRow className="bg-muted/50"><TableHead>Data</TableHead><TableHead>Utente</TableHead><TableHead>Azione</TableHead><TableHead>Entità</TableHead><TableHead>Società</TableHead><TableHead>Dettaglio</TableHead></TableRow></TableHeader>
              <TableBody>
                {data.events.map((e) => (
                  <TableRow key={e.id}>
                    <TableCell className="font-mono text-xs">{fmtDateTime(e.at)}</TableCell><TableCell className="text-sm">{e.user_name}</TableCell>
                    <TableCell className="micro-label">{e.action}</TableCell><TableCell className="font-mono text-xs">{e.entity}{e.entity_id ? ` · ${e.entity_id.slice(0, 8)}` : ""}</TableCell>
                    <TableCell className="text-sm">{nameOf("companies", e.company_id, "code")}</TableCell>
                    <TableCell className="max-w-md truncate font-mono text-[11px] text-muted-foreground">{JSON.stringify(e.data)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </TabsContent>
        <TabsContent value="access">
          <div className="overflow-x-auto border bg-white" data-testid="audit-access-table">
            <Table>
              <TableHeader><TableRow className="bg-muted/50"><TableHead>Data</TableHead><TableHead>Email</TableHead><TableHead>IP</TableHead><TableHead>Esito</TableHead></TableRow></TableHeader>
              <TableBody>
                {data.access.map((a) => (
                  <TableRow key={a.id}>
                    <TableCell className="font-mono text-xs">{fmtDateTime(a.at)}</TableCell><TableCell className="font-mono text-xs">{a.email}</TableCell>
                    <TableCell className="font-mono text-xs">{a.ip}</TableCell><TableCell className={a.success ? "text-emerald-700" : "text-red-600"}>{a.success ? "Riuscito" : "Fallito"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
